<template>

</template>

<script>
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'AhrefsAnalytics',
  created() {
    if (import.meta.env.VITE_APP_ENV === 'local') {
      return;
    }

    // Load Ahrefs Analytics script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://analytics.ahrefs.com/analytics.js';
    script.setAttribute('data-key', '6pOL9aba+l4VaVVSIrznPA');
    document.head.appendChild(script);
  },
})
</script>

<style scoped lang="scss">

</style>
